/*  eslint no-shadow: ["error", { "allow": ["state"] }] */
/*  eslint no-param-reassign: ["error", { "props": false }] */
import Vue from "vue";
import Vuex from "vuex";
import { OrderService } from "@/services/order.service";
import { HelperService } from "@/services/helper.service";

Vue.use(Vuex);

const state = {
  orders: [],
  selected: {},
  loading: false,
  totalCount: 0
};

const getters = {
  orders: state => state.orders,
  selectedOrder: state => state.selected,
  onLoading: state => state.loading,
  total: state => state.totalCount
};

const mutations = {
  setSelected(state, sel) {
    state.selected = sel;
  },
  setList(state, sel) {
    state.orders = sel;
  },
  setTotal(state, sel) {
    state.totalCount = Number(sel);
  },
  setLoading(state, sel) {
    state.loading = sel;
  }
};

const actions = {
  async ajaxOrderSetSelected({ commit }, payload) {
    await HelperService.genericSetSelected(
      commit,
      OrderService.fetchOne,
      payload.id
    );
  },

  async ajaxOrderFetchAll({ commit }, payload) {
    let searchFilterPagination = HelperService.localToJSONAPIPagination(
      payload
    );
    searchFilterPagination.include = "tenant,customer,tickets";

    await HelperService.genericFetchAll(
      commit,
      OrderService.fetchAll,
      searchFilterPagination,
      null,
      null
    );
  },

  async ajaxOrderCreateOrUpdate({ commit }, payload) {
    return HelperService.genericCreateOrUpdate(
      commit,
      OrderService.createOrUpdate,
      payload
    );
  },

  async ajaxOrderDelete({ commit }, payload) {
    return HelperService.genericDelete(commit, OrderService.delete, payload.id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
